import { useApiClient } from "../../shared/customHooks";
import { InviteUserForm } from "../../shared/formObjects/inviteUserForm";
import { useGlobalContext } from "../../shared/GlobalContext";
import FormContainer from "../form/FormContainer";
import { useEffect, useState } from "react";

function InviteUserComponent({ data, onInvite }: any) {
  const api = useApiClient("UserLink", { identity: true });
  const [formContext, setFormContext] = useState<any>({ providerName: "" });
  const {
    accountInfo: { isManager },
  } = useGlobalContext();

  const handleSuccess = () => {
    onInvite(true);
  };

  useEffect(() => {
    if (data != null) {
      const providerName = data.providerBase.providerDetails.providerName;
      setFormContext({ providerName: providerName });
    }
  }, []);

  return (
    <>
      <FormContainer
        disabled={!isManager}
        id={data.id}
        apiClient={api}
        formBody={InviteUserForm}
        data={data}
        showInternalNotes={false}
        saveSuccessCB={handleSuccess}
        hideCancelButton={true}
        submitBtnTitle="Submit"
        formContext={formContext}
      />
    </>
  );
}

export default InviteUserComponent;
